import React, { useState } from "react";
import Header from "../layouts/Header";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { Box, InputLabel, Typography } from "@material-ui/core";
import UserDataTable from "./users/UserDatatable";
import { Route, useHistory } from "react-router-dom";
// import UserProfile from './users/UserProfile';
import useGeneralStyle from "../assets/css/general";
import AdminDataTable from "./users/AdminDatatable";
import SuppliersDatatable from "./users/SuppliersDatatable";
import DeliveryStaffDatatable from "./users/DeliveryStaffDatatable";
import POSDataTable from "./users/POSDatatable";
import ServiceStaffDatatable from "./users/ServiceStaffDatatable";
import { useAuth } from "../providers/AuthProvider";
import { PERMISSIONS } from "../store/constants";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import PartnersDatatable from "./users/PartnersDatatable";
import FormFieldManagement from "./users/FormFieldManagement";
import Configurations from "./businesses/Configurations";

function UserManagement() {
  const { user_type } = useParams();
  const [userType, setUserType] = useState("pos");
  const history = useHistory();
  const globalClasses = useGeneralStyle();
  const { hasAccess } = useAuth();

  const handleUserType = (e) => {
    setUserType(e.target.value);
    switch (e.target.value) {
      // case "admins":
      //   history.replace("/users/admins");
      //   break;

      case "partners":
        history.replace("/users/partners");
        break;
      default:
        history.replace("/users/partners");
        break;
    }
  };

  return (
    <>
      <Header>
        <Box flexGrow={1}>
          <InputLabel
            className={globalClasses.filterLabel}
            style={{ fontSize: "10px", color: "#6f6d6d" }}
          >
            Select User Type:
          </InputLabel>
          <Select
            style={{ fontSize: "14px" }}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={user_type}
            onChange={handleUserType}
          >
            {/* <MenuItem value="all">All Users</MenuItem>
            <MenuItem value="admins">All Admins</MenuItem> */}
            <MenuItem value="partners">Partners</MenuItem>
            {/* <MenuItem value="walk-in">All Walkin</MenuItem> */}
            <MenuItem value="suppliers">All Suppliers</MenuItem>
            {hasAccess(PERMISSIONS.STAFF_MANAGEMENT) && (
              <MenuItem value="service-staff">All Staff</MenuItem>
            )}
            {/* <MenuItem value="staff">All Delivery Staff</MenuItem>*/}
          </Select>
        </Box>
      </Header>

      {/* <Route exact path="/users/admins" component={AdminDataTable} />
      <Route exact path="/users/pos" component={POSDataTable} />
      <Route exact path="/users" component={UserDataTable} />
      <Route
        exact
        path="/users/delivery-staff"
        component={DeliveryStaffDatatable}
      /> */}

      {/* {JSON.stringify(userData?.permissions.includes(PERMISSIONS.STAFF_MANAGEMENT))} */}
      <Route exact path="/users/admins" component={AdminDataTable} />
      <Route exact path="/users/partners" component={PartnersDatatable} />
      <Route exact path="/users/suppliers" component={SuppliersDatatable} />
      <Route exact path="/users/walk-in" component={POSDataTable} />
      <Route exact path="/users/partners/:business_id/form" component={FormFieldManagement} />
      <Route exact path="/users/partners/configuration" component={Configurations} />
      {hasAccess(PERMISSIONS.STAFF_MANAGEMENT) && (
        <Route
          exact
          path="/users/service-staff"
          component={ServiceStaffDatatable}
        />
      )}
    </>
  );
}

export default UserManagement;
